import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import http from '@lib/http-client'

import { FaxData, FaxState } from './types'
import { encode as base64_encode } from 'base-64'

export const useFaxStore = create<FaxState>()(
  devtools(
    persist(
      (set, get) => ({
        faxDataByUserId: {},

        getFaxDataByUserId: (userId: number) => {
          return get().faxDataByUserId[userId]
        },

        sendFax: async (faxData: FaxData) => {
          /*
            * Fax
          curl -i -X POST \
          -H "Authorization: Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGllbnRfcGlkIjoxLCJ1c2VyX2lkIjoyOSwiaWF0IjoxNzMyODAxMTkzLjI1NTY0Nn0.nrc2xTa3BoYnvk7DsNuySxWOMlFsDDtcIDfJkmfCydg" \
          -H "Content-Type: application/json" \
          -d '{"fax_number": "123456789", "title": "Test Fax", "message": "This is a test message", "action_required": true}' \
          http://localhost:8000/flipper/send_fax
            */
          try {
            const endpoint = '/send_fax'
            const content = {
              ...faxData,
              message: base64_encode(faxData.message)
            }
            const response = await http.post(endpoint, content)

            return response?.success === true
          } catch (err) {
            console.log('sendFax error: ', err)
            return false
          }
        },

        clear: () => {
          set({ faxDataByUserId: {} })
        }
      }),
      {
        name: 'fax-zustand-storage',
        storage: createJSONStorage(() => sessionStorage),
        partialize: state => ({
          faxDataByUserId: state.faxDataByUserId
        })
      }
    )
  )
)
